export const convertCData = (arr) => {
    arr.forEach(a => {
        if(a.cdata) {
            try {
                a.cdata = JSON.parse(a.cdata);
            } catch(e) {}
        }
    });
    return arr;
}

export const toTitleCase = (str) => {
    return str.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

export const caStateOpts = [
    {id: '', display: 'Select State'},
    { id: 'AL', display: 'Alberta'},
    { id: 'BC', display: 'British Columbia'},
    { id: 'MA', display: 'Manitoba'},
    { id: 'NB', display: 'New Brunswik'},
    { id: 'NL', display: 'Newfoundlend and Labrador'},
    { id: 'NS', display: 'Nova Scotia'},
    { id: 'ON', display: 'Ontario'},
    { id: 'PEI', display: 'Price Edward Island'},
    { id: 'QU', display: 'Quebeck'},
    { id: 'SA', display: 'Saskatchewan'},
];

export const usStateOpts = [
    {id: '', display: 'Select State'},
    { id: 'AL', display: 'Alabama'},
    { id: 'AK', display: 'Alaska'},
    { id: 'AZ', display: 'Arizona'},
    { id: 'AR', display: 'Arkansas'},
    { id: 'CA', display: 'California'},
    { id: 'CO', display: 'Colorado'},
    { id: 'CT', display: 'Connecticut'},
    { id: 'DC', display: 'District of Columbia'},
    { id: 'DE', display: 'Delaware'},
    { id: 'FL', display: 'Florida'},
    { id: 'GA', display: 'Georgia'},
    { id: 'HI', display: 'Hawaii'},
    { id: 'ID', display: 'Idaho'},
    { id: 'IA', display: 'Iowa'},
    { id: 'IL', display: 'Illinois'},
    { id: 'IN', display: 'Indiana'},
    { id: 'KS', display: 'Kansas'},
    { id: 'KY', display: 'Kentucky'},
    { id: 'LA', display: 'Louisiana'},
    { id: 'ME', display: 'Maine'},
    { id: 'MD', display: 'Maryland'},
    { id: 'MA', display: 'Massachusetts'},
    { id: 'MI', display: 'Michigan'},
    { id: 'MN', display: 'Minnesota'},
    { id: 'MS', display: 'Mississippi'},
    { id: 'MO', display: 'Missouri'},
    { id: 'MT', display: 'Montana'},
    { id: 'NE', display: 'Nebraska'},
    { id: 'NH', display: 'New Hampshire'},
    { id: 'NJ', display: 'New Jersey'},
    { id: 'NM', display: 'New Mexico'},
    { id: 'NV', display: 'Nevada'},
    { id: 'NY', display: 'New York'},
    { id: 'NC', display: 'North Carolina'},
    { id: 'ND', display: 'North Dakota'},
    { id: 'OH', display: 'Ohio'},
    { id: 'OK', display: 'Oklahoma'},
    { id: 'OR', display: 'Oregon'},
    { id: 'PA', display: 'Pennsylvania'},
    { id: 'RI', display: 'Rhode Island'},
    { id: 'SC', display: 'South Carolina'},
    { id: 'SD', display: 'South Dakota'},
    { id: 'TN', display: 'Tennessee'},
    { id: 'TX', display: 'Texas'},
    { id: 'UT', display: 'Utah'},
    { id: 'VT', display: 'Vermont'},
    { id: 'VA', display: 'Virginia'},
    { id: 'WA', display: 'Washington'},
    { id: 'WV', display: 'West Virginia'},
    { id: 'WI', display: 'Wisconsin'},
    { id: 'WY', display: 'Wyoming'}
];


// WEBPACK FOOTER //
// ./src/utils/index.js